// ----------------------------------------------------------------------------
// Section: Locations
// ----------------------------------------------------------------------------
//
// This is a section that displays location cards in a carousel
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_locations.scss';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--locations';
const CAROUSEL_CLASS = 'carousel--locations';
const CAROUSEL_SECTION_SELECTOR = '.locations';
const CAROUSEL_SECTION_CLASS = 'locations';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_SCROLLBAR_SELECTOR       = '.swiper-scrollbar';


// -------------------------------------
// Hooks
// -------------------------------------
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {

        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

        // Generate unique btn classes for slider arrows
        element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`);
        element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-btn-next-${index}`);
        element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-scrollbar-${index}`);
        const scrollbar = element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR);

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [Navigation, Scrollbar, A11y, Keyboard],
            slidesPerView: 1.1,
            spaceBetween: 10,
            centerInsufficientSlides: true,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            grabCursor: true,

            breakpoints: {
                0: {
                    slidesPerView: 1.2264,
                    spaceBetween: 13.66,
                },
                681: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                }
            },
            navigation: {
                nextEl: `.${CAROUSEL_SECTION_CLASS}-btn-next-${index}`,
                prevEl: `.${CAROUSEL_SECTION_CLASS}-btn-prev-${index}`
            },
            scrollbar: {
                el: scrollbar,
                draggable: true,
            }
        });

        swiper.slides.forEach(function(slide, index) {
            const slideLink = slide.querySelector('a');
            slideLink?.addEventListener('focus', function() {
                swiper.slideTo(index);
            });
        });
    });
